import React, { useContext, useState } from "react";  

function NewGalleryCreateP({ updateGalleryData }) {
  const [galleryName, setGalleryName] = useState("");
 

  // Handle input change
  const handleChange = (event) => {
    const newValue = event.target.value;
    setGalleryName(newValue);
    updateGalleryData(newValue);
  };

  return (
    <div>
      <label
        htmlFor="folder_name"
        className="block mb-2 text-sm font-medium"
      >
        Album Name
      </label>

      <div>
        <label
          htmlFor="folder_name"
          className="block mb-2 text-xs font-medium  "
        >
          Enter a Album Name*
        </label>
        <input
          type="text"
          id="folder_name"
          value={galleryName}
          onChange={handleChange}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Enter Album Name"
          required
        />
      </div>
    </div>
  );
}

export default NewGalleryCreateP;
